import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { DeletePaymentApi } from '../../redux/payments/paymentApiCalls';
import { ShowPaymentContext } from './types';
import { Timeout } from '../../functions/functions';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';

interface props {
  modal: boolean,
  toggle: any
}

const DeletePaymentModal: React.FC<props> = ({ modal, toggle }) => {
  const [loading, setLoading] = useState(false)
  const dispatch: any = useDispatch()
  const { setShowSuccessMsg, selectedPayment } = useContext(ShowPaymentContext)

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    try {
      setLoading(true)
      let response = await dispatch(DeletePaymentApi(selectedPayment._id, "")) // selectedPayment.doctor?._id
      if(response === true) {
        setShowSuccessMsg(true)
        setTimeout(() => setShowSuccessMsg(false), Timeout)
        toggle()
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                  >
                    <ButtonsForm loading={loading} typeBtn='Supprimer' toggle={toggle} />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default DeletePaymentModal
